import React from 'react';
import PropTypes from 'prop-types';

const LinkRedirection = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3337_6490)">
      <path d="M96 1H0V97H96V1Z" fill="#69F0AE" />
      <path
        d="M19.335 38.8604H55.755C56.088 38.8642 56.4062 38.9982 56.6417 39.2337C56.8771 39.4692 57.0111 39.7874 57.015 40.1204V76.1204C57.015 76.5619 56.8396 76.9854 56.5273 77.2977C56.2151 77.6099 55.7916 77.7854 55.35 77.7854H19.725C19.5063 77.7934 19.2882 77.7582 19.0831 77.6819C18.878 77.6055 18.69 77.4895 18.5298 77.3404C18.3696 77.1914 18.2403 77.0122 18.1494 76.8131C18.0585 76.6141 18.0077 76.399 18 76.1804V40.1804C18.0039 39.8474 18.1379 39.5292 18.3734 39.2937C18.6088 39.0582 18.927 38.9242 19.26 38.9204L19.335 38.8604Z"
        fill="#F5F6FB"
      />
      <path
        d="M19.29 38.4998H55.8C56.1222 38.4998 56.4313 38.6278 56.6591 38.8557C56.887 39.0835 57.015 39.3926 57.015 39.7148V43.3598H18V39.6398C18 39.4802 18.0314 39.3223 18.0925 39.1748C18.1535 39.0274 18.243 38.8935 18.3559 38.7807C18.4687 38.6678 18.6026 38.5783 18.75 38.5173C18.8975 38.4562 19.0554 38.4248 19.215 38.4248L19.29 38.4998Z"
        fill="#808080"
      />
      <path
        opacity="0.15"
        d="M70.545 24.2197H38.52C36.5981 24.2197 35.04 25.7778 35.04 27.6997V60.1297C35.04 62.0517 36.5981 63.6097 38.52 63.6097H70.545C72.467 63.6097 74.025 62.0517 74.025 60.1297V27.6997C74.025 25.7778 72.467 24.2197 70.545 24.2197Z"
        fill="#808080"
      />
      <path
        opacity="0.15"
        d="M41.31 45.7002H21.165V74.6352H41.31V45.7002Z"
        fill="#808080"
      />
      <path
        opacity="0.15"
        d="M54.7195 45.7002H43.0195V74.6352H54.7195V45.7002Z"
        fill="#808080"
      />
      <path
        d="M21.7495 42.2198C22.4288 42.2198 22.9795 41.6691 22.9795 40.9898C22.9795 40.3105 22.4288 39.7598 21.7495 39.7598C21.0702 39.7598 20.5195 40.3105 20.5195 40.9898C20.5195 41.6691 21.0702 42.2198 21.7495 42.2198Z"
        fill="#69F0AE"
      />
      <path
        d="M25.3198 42.2198C25.9992 42.2198 26.5498 41.6691 26.5498 40.9898C26.5498 40.3105 25.9992 39.7598 25.3198 39.7598C24.6405 39.7598 24.0898 40.3105 24.0898 40.9898C24.0898 41.6691 24.6405 42.2198 25.3198 42.2198Z"
        fill="white"
      />
      <path
        d="M75.525 20.1846H41.43C40.0879 20.1846 39 21.2725 39 22.6146V56.7096C39 58.0516 40.0879 59.1396 41.43 59.1396H75.525C76.8671 59.1396 77.955 58.0516 77.955 56.7096V22.6146C77.955 21.2725 76.8671 20.1846 75.525 20.1846Z"
        fill="white"
      />
      <path
        d="M40.215 20.1846H76.74C76.8996 20.1846 77.0576 20.216 77.205 20.2771C77.3524 20.3381 77.4863 20.4276 77.5991 20.5404C77.712 20.6533 77.8015 20.7872 77.8625 20.9346C77.9236 21.082 77.955 21.24 77.955 21.3996V24.9996H39V21.3996C39 21.0773 39.128 20.7683 39.3559 20.5404C39.5837 20.3126 39.8928 20.1846 40.215 20.1846Z"
        fill="#808080"
      />
      <path
        d="M42.7349 23.8604C43.4142 23.8604 43.9649 23.3097 43.9649 22.6304C43.9649 21.9511 43.4142 21.4004 42.7349 21.4004C42.0556 21.4004 41.5049 21.9511 41.5049 22.6304C41.5049 23.3097 42.0556 23.8604 42.7349 23.8604Z"
        fill="#69F0AE"
      />
      <path
        d="M46.3052 23.8604C46.9845 23.8604 47.5352 23.3097 47.5352 22.6304C47.5352 21.9511 46.9845 21.4004 46.3052 21.4004C45.6259 21.4004 45.0752 21.9511 45.0752 22.6304C45.0752 23.3097 45.6259 23.8604 46.3052 23.8604Z"
        fill="white"
      />
      <path d="M62.1602 28H43.4102V55.795H62.1602V28Z" fill="#F5F6FB" />
      <path d="M74.6254 28H63.7354V55.795H74.6254V28Z" fill="#F5F6FB" />
    </g>
    <defs>
      <clipPath id="clip0_3337_6490">
        <rect y="0.5" width="96" height="96" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

LinkRedirection.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

export default LinkRedirection;
